import { Outlet } from 'react-router-dom';
import React from 'react';
import { GeneralNavbar } from '../components/GeneralNavbar';
import { Footer } from '../components/Footer';
import { GeneralInformation } from '../components/GeneralInformation';
import { Box } from '@mui/material';
import { StyledAuthLayout } from '../theme/StyledElements';

export function AuthLayout(): React.ReactElement {
    return (
        <StyledAuthLayout>
            <GeneralNavbar />
            <Box sx={{ flexGrow: 1, display: 'grid' }}>
                <Box sx={{ display: 'flex', flexGrow: 1 }}>
                    <Box sx={{ width: '50%', flexGrow: 1 }}>
                        <Outlet />
                    </Box>
                    <Box sx={{ width: '50%', flexGrow: 1 }}>
                        <GeneralInformation />
                    </Box>
                </Box>
            </Box>
            <Footer />
        </StyledAuthLayout>
    );
}
